import type { JobType } from '@/features/jobs/types/job'

const jobTypeLabels: Record<JobType, string> = {
  new_installation: 'New installation',
  remediation: 'Remediation',
}

export const formatJobType = (jobType: JobType) => jobTypeLabels[jobType]
